import { render, staticRenderFns } from "./DataReport.vue?vue&type=template&id=41cc050f&scoped=true"
import script from "./DataReport.vue?vue&type=script&lang=js"
export * from "./DataReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cc050f",
  null
  
)

export default component.exports